import isEqual from 'lodash.isequal';
import React from 'react';
import { useSelector } from 'react-redux';
import { isValidGoCombinedDeliveryButton } from '../../../app/Helper/DeliveryHelper';

/**
 * 묶음배송 컴포넌트
 * MW MA 노출
 */
function DeliveryCombine() {
  const { intergratedDeals } = useSelector(
    state => ({
      intergratedDeals: state.default.intergratedDeals
        ? state.default.intergratedDeals.response
        : null,
    }),
    isEqual
  );
  const combinedDeliveryDeals =
    !intergratedDeals || TMON.oApp.oUtil.isEmpty(intergratedDeals.data)
      ? {}
      : intergratedDeals.data.COMBINED_DELIVERY_DEALS;
  const isDeliveryCombineRender =
    TMON.sDevice !== 'PW' && combinedDeliveryDeals.partnerUrl;

  if (!isDeliveryCombineRender || !isValidGoCombinedDeliveryButton()) {
    return null;
  }

  const onClick = e => {
    e.stopPropagation();
    e.preventDefault();

    const url = combinedDeliveryDeals.partnerUrl;

    if (TMON.view_mode === 'app') {
      try {
        TMON.app.callApp("webview", "showView", "묶음배송 상품", TMON.util.aup(url, TMON.sAppQuery), true);
      } catch (err) {
        console.error(err);
        alert(
          '일시적인 오류로 묶음배송 상품 조회에 실패하였습니다. 잠시 후 다시 시도해 주십시오. 문제가 지속되면 고객센터로 문의를 부탁드립니다.'
        );
      }
    } else {
      window.location = url;
    }
  };

  return (
    <a className="link_shipping" onClick={onClick}>
      <span className="text">묶음배송상품 보기</span>
    </a>
  );
}

export default DeliveryCombine;
